import { Alert } from 'antd';

const ValidationErrorAlert = ({ messages, onClose, title = 'Validation error' }) => {
  if (!messages?.length) {
    return null;
  }

  return (
    <Alert
      type="error"
      showIcon
      closable
      onClose={onClose}
      message={title}
      description={(
        <ul style={{ margin: 0, paddingInlineStart: 20 }}>
          {messages.map((msg) => (
            <li key={msg}>{msg}</li>
          ))}
        </ul>
      )}
      style={{ marginBottom: 16 }}
    />
  );
};

export default ValidationErrorAlert;
